import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { Globals } from '../../../../globals';
import {ProductCreateFoodcostPreparationPage} from "../../product-create/product-create-foodcost/product-create-foodcost-preparation/product-create-foodcost-preparation";


/**
 * Generated class for the ProductViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-preparation',
    templateUrl: 'product-view-preparation.html',
})
export class ProductViewPreparationPage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public globals: Globals) {
    }

    edit() {
        this.navCtrl.push(ProductCreateFoodcostPreparationPage, {
            update_state: true,
            product_uid: this.product.UID,
            recipe: this.product.recipe,
            tools: this.product.tools,
            time: this.product.time,
            preparation: this.product.preparation,
            product_name: this.product.name,
            product: this.product
        })


    }


}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-preparation/product-view-preparation.ts